export const userRoles = {
    SUPER_USER: "super-user",
    HOD: "hod",
    CONSULTANT: "consultant",
    ASSISTANT: "assistant",
    AUDITOR: "auditor",
}

export const caseStatus = {}

export const userPermissions = {
    CASE_STATUS_DISCUSS_LIST: "case-status-discuss-list",
    CASE_STATUS_SET_STATUS: "case-status-set-status",
    CASES_MY_CASES: "cases-my-cases",
    NOTIFICATIONS_LIST: "notifications-list",
    NOTIFICATIONS_CREATE: "notifications-create",
    NOTIFICATIONS_DELETE: "notifications-delete",
    PROFILE_CHANGE_PASSWORD: "profile-change-password",
    PROFILE_UPDATE: "profile-update",
    COMORBIDITIES_LIST: "comorbidities-list",
    COMORBIDITIES_CREATE: "comorbidities-create",
    COMORBIDITIES_UPDATE: "comorbidities-update",
    COMORBIDITIES_DELETE: "comorbidities-delete",
    COMORBIDITIES_SHOW: "comorbidities-show",
    PROCEDURES_LIST: "procedures-list",
    PROCEDURES_CREATE: "procedures-create",
    PROCEDURES_SHOW: "procedures-show",
    PROCEDURES_UPDATE: "procedures-update",
    PROCEDURES_DELETE: "procedures-delete",
    COMPLICATIONS_CREATE: "complications-create",
    COMPLICATIONS_LIST: "complications-list",
    COMPLICATIONS_DELETE: "complications-delete",
    COMPLICATIONS_UPDATE: "complications-update",
    GROUPS_CREATE: "groups-create",
    GROUPS_LIST: "groups-list",
    GROUPS_DELETE: "groups-delete",
    GROUPS_UPDATE: "groups-update",
    DEPARTMENTS_LIST: "departments-list",
    DEPARTMENTS_CREATE: "departments-create",
    DEPARTMENTS_DELETE: "departments-delete",
    DEPARTMENTS_SHOW: "departments-show",
    DEPARTMENTS_UPDATE: "departments-update",
    POSITIONS_LIST: "positions-list",
    POSITIONS_CREATE: "positions-create",
    POSITIONS_DELETE: "positions-delete",
    POSITIONS_SHOW: "positions-show",
    POSITIONS_UPDATE: "positions-update",
    USERS_LIST: "users-list",
    USERS_CREATE: "users-create",
    USERS_DELETE: "users-delete",
    USERS_SHOW: "users-show",
    USERS_UPDATE: "users-update",
    LOGGEDIN_USERS_LIST: "loggedIn-users-list",
    PERMISSIONS_LIST: "permissions-list",
    ROLES_LIST: "roles-list",
    ROLES_CREATE: "roles-create",
    ROLES_DELETE: "roles-delete",
    ROLES_SHOW: "roles-show",
    ROLES_UPDATE: "roles-update",
    CASES_LIST: "cases-list",
    CASES_STORE: "cases-store",
    CASES_UPCOMING: "cases-upcoming",
    CASES_APPROVED: "cases-approved",
    CASES_ARCHIVED: "cases-archived",
    CASES_DRAFT: "cases-draft",
    CASES_PUBLISHED: "cases-published",
    CASES_SHOW: "cases-show",
    CASES_UPDATE: "cases-update",
    CASES_DELETE: "cases-delete",
    CASES_RECREATE: "cases-re-create",
    CASES_BOOKMARK: "cases-bookmark",
    CASES_AUDITS_LIST: "case-audits-list",
    RESET_PASSWORDS_LIST: "reset-password-list",
    RESET_PASSWORDS_UPDATE: "reset-password-update",
    CASES_AUDITS_SHOW: "case-audits-show",
    FLAGGED_CASES_BOOKMARK: "flagged-cases-bookmark",
    CASES_MARK_DISCUSSED: "cases-mark-as-discussed",
    COMMENTS_STORE: "comments-store",
    COMMENTS_DELETE: "comments-delete",
    COMMENTS_CASE_COMMENTS: "comments-case-comments",
    FLAGGED_CASES_LIST: "flagged-cases-list",
    FLAGGED_CASES_OPENED: "flagged-cases-opened",
    FLAGGED_CASES_CLOSED: "flagged-cases-closed",
    FLAGGED_CASES_FLAG: "flagged-cases-flag",
    FLAGGED_CASES_COMMENT: "flagged-cases-comment",
    FLAGGED_CASES_CLOSE: "flagged-cases-close",
    CASES_DELETE: "cases-delete",
    CASES_CONSULTANT_DELETE: "consultant-cases-delete",
    CONTACT_REQUEST_LIST: "contact-request-list",
    CONTACT_REQUEST_STORE: "contact-request-store",
    PENDING_REVIEW_BY_ME: "pending-review-by-me",
    PERMISSIONS_CURRENT_USER_PERMISSIONS: "permissions-current-user-permissions",
    ENTITY_DEPARTMENT_USERS_DEPARTMENTS: "entity-department-users-departments",
    ENTITY_DEPARTMENT_DEPARTMENT_ENTITIES_LIST: "entity-department-department-entities-list",
}